import React, { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Button, FormContext, FormItem, FormSubmitButton, MasterDetailForm, Widget } from '@digital/ui';
import { dadosGeraisState, ordemCompraIdState, reloadDadosGeraisState, reloadState, reloadVendorListState, reloadWidgetTimelineState } from '../atoms';
import { enviarVencedorEAreaTecnica } from '@app/api/sas/ordemCompra';
import { TagComponentV2 } from '@app/components/Tag/indexv2';
import { Visibility } from '@app/components';
import { Modal, Tooltip } from 'antd'
import * as Yup from 'yup';
import TipoOptions from '@app/types/core.types';
import { Usuario, getAllUsuariosMRN } from '@app/api/usuario';
import { uniqBy } from 'lodash';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';

interface Props {
}

const ModalNotificarVencedorAreaTecnica = ({ }: Props) => {

    const ordemCompraId = useRecoilValue(ordemCompraIdState);
    const dadosGerais = useRecoilValue(dadosGeraisState);
    const [reload, setReload] = useRecoilState(reloadState);
    const [open, setOpen] = useState(false);
    const [emails, setEmails] = useState<TipoOptions[]>([]);
    const [reloadWidgetTimeline, setReloadWidgetTimeline] = useRecoilState(reloadWidgetTimelineState);
    const [reloadDadosGerais, setReloadDadosGerais] = useRecoilState(reloadDadosGeraisState);

    const onModalOpen = () => {
        setOpen(!open);
    }

    useEffect(() => {
        getAllUsuariosMRN()
            .then((response: Usuario[] | undefined) => {
                if (response) {
                    const emailsOpts = response.map((item: Usuario, index, self) => {
                        return {
                            text: item.email,
                            value: item.email
                        } as TipoOptions
                    });
                    setEmails([...uniqBy(emailsOpts, 'value').sort((a: any, b: any) => (a.value - b.value))])
                }
            })
    }, [])

    const onSubmit = (values: any) => {
        Modal.confirm({
            title: 'Confirmação Envio de Email',
            content:
                'Você deseja enviar este e-mail?',
            cancelText: 'Não',
            onCancel: () => {
                enviarVencedorEAreaTecnica(
                    {
                        ordemCompraId: ordemCompraId,
                        destinatarios: values.destinatarios,
                        enviarEmail: false
                    }).then((response: any) => {
                        if (response) {
                            setReload(!reload);
                            setOpen(false);
                            setReloadWidgetTimeline(!reloadWidgetTimeline);
                            setReloadDadosGerais(!reloadDadosGerais);
                        };
                    });
            },
            okText: 'Sim',
            onOk: () => {
                enviarVencedorEAreaTecnica(
                    {
                        ordemCompraId: ordemCompraId,
                        destinatarios: values.destinatarios
                    }).then((response: any) => {
                        if (response) {
                            setReload(true);
                            setOpen(false);
                            setReloadWidgetTimeline(!reloadWidgetTimeline);
                            setReloadDadosGerais(!reloadDadosGerais);
                        };
                    });
            },
        });
    }

    return (
        <>
            <Tooltip title={'Notificar Vencedor e Área Técnica'}>
                <Button
                    onClick={onModalOpen}
              className={dadosGerais.isEmailVencedorEnviado? 'button-modal-acoes-gerais-disabled' :''}
              disabled={dadosGerais.isEmailVencedorEnviado && dadosGerais.tipo !== ETipoDemanda.NovaContratacao}
                >
                    Notificar Vencedor e Área Técnica
                </Button>
            </Tooltip>

            <Visibility visible={open}>
                <MasterDetailForm
                    key="formButtonModalNotificarVencedorAreaTecnica"
                    onSubmit={onSubmit}
                    validationSchema={Yup.object().shape({
                        destinatarios: Yup.array()
                            .min(1, 'É necessário adicionar no mínimo 1 destinatário')
                    })}>
                    <Modal
                        onCancel={() => setOpen(false)}
                        title='Notificar Vencedor e Área Técnica'
                        visible={open}
                        footer={[
                            <Button
                                title='Fechar'
                                onClick={() => {
                                    setOpen(false);
                                }}
                                type="link"
                            />,
                            <FormSubmitButton noIcon type="primary" title='Enviar' />
                        ]}
                    >
                        <Widget >
                            <FormContext.Consumer>
                                {({ formProps }) =>
                                (
                                    <FormItem name='destinatarios'>
                                        <TagComponentV2
                                            buttonText="Novo destinatário"
                                            isValidateEmail
                                            hasLoadSelect={true}
                                            onLoadListSelect={async () =>
                                                emails
                                            }
                                            onChange={function (value: string[]): void {
                                                if (formProps) {
                                                    formProps.setFieldValue('destinatarios', value)
                                                }
                                            }}
                                        />
                                    </FormItem>
                                )}
                            </FormContext.Consumer>
                        </Widget>
                    </Modal>
                </MasterDetailForm>
            </Visibility>
        </>
    );
};
export default ModalNotificarVencedorAreaTecnica;
